module.exports = __webpack_public_path__ + "img/ygSDK.c4f90583.png";